import React, { Component } from 'react'
import { Modal, Button,Row,Col,Form,Image } from "react-bootstrap";
import loader from '../../images/loader.gif';


class MaxLimitEnrollChecking extends Component {
    constructor(props) {
        super(props)
        this.state = {
           
        }
      
    }
    render() {
        return (
            <Modal {...this.props} 
            size="sm"   aria-labelledby="example-modal-sizes-title-lg" className="">
                <Modal.Body className={this.props.modalViewType == "voter" ? "" : "modal_css_limit"}>
                      <Row>
                         <Col>
                            <h2 className='text-center'><i class="fa-regular fa-circle-xmark color_red f-42"></i></h2>
                            <p className='mt-3 color_red text-center fw-bold'>
                            గమనిక !! ప్రతి రోజు భవిష్యతుకు గ్యారంటీ కార్యక్రమం లో గరిష్టంగా 40 కుటంబాలను మాత్రమే నమోదు చేయగలము. మీరు భవిష్యతుకు గ్యారంటీ కార్యక్రమాన్ని రేపు కొనసాగించి ఈ కార్యక్రమాన్ని విజయవంతం చేయగలరు.
                            </p>
                            <Button variant="dark" className='f-12 float-right mt-2 btn-sm' onClick={() => this.props.closeLimitModal()}>Close Modal</Button> 
                         </Col>
                      </Row>
                </Modal.Body>
            </Modal>
            
        )
    }
}
export default MaxLimitEnrollChecking;
  

